module.exports = __webpack_public_path__ + "img/content.abb36c8b.svg";